export default "<main *ngIf=\"envLoaded\">\n    <router-outlet></router-outlet>\n</main>\n\n<!-- <app-my-loader></app-my-loader> -->"